import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useWebsite } from "context/client/website";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import FormikSelect from "components/formik/FormikSelect";
import FormikTaxInput from "components/formik/FormikTaxInput";

import countries from "libs/countries.json";
import billingDataSchema from "libs/validations/billingDataSchema";

const BillingDataModal = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();

  const { data, updateData } = useWebsite();

  const onSubmit = async (values, setSubmitting) => {
    try {
      await updateData(values);
      onClose();
    } catch (err) {
      setSubmitting(false);
    }
  };

  const countries_options = countries?.map(({ name, name_pl, code }) => ({
    label: i18n?.language === "pl" ? name_pl || name : name,
    value: code,
  }));

  return (
    <Formik
      initialValues={{
        billing_data: {
          name: data?.billing_data?.name,
          tax: {
            code: data?.billing_data?.tax?.code,
            number: data?.billing_data?.tax?.clean_number,
          },
          street: data?.billing_data?.street,
          post_code: data?.billing_data?.post_code,
          city: data?.billing_data?.city,
          country: data?.billing_data?.country,
        },
      }}
      enableReinitialize
      validationSchema={billingDataSchema}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values, setSubmitting);
      }}
    >
      {({ values, isSubmitting, submitForm }) => (
        <ModalNew
            title={t("Change invoice details")}
            description={t("Update the name, tax ID number, and address.")}
            variant="wide"
            loading={isSubmitting}
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={submitForm}
          >
            <Form autoComplete="off">
            <div className="form form--columns">
              <div className="form__column">
                <FormikInput
                  name="billing_data.name"
                  label={t("Name")}
                  disabled={isSubmitting}
                  placeholder="Acme Corporation"
                />
              </div>
              <div className="form__column">
                <FormikTaxInput
                  label={t("Tax identification number")}
                  name="billing_data.tax"
                  disabled={isSubmitting}
                />
              </div>
              <div className="form__column">
                <FormikInput
                  name="billing_data.street"
                  label={t("Street")}
                  disabled={isSubmitting}
                  placeholder="Main Street 13A"
                />
              </div>
              <div className="form__column">
                <FormikInput
                  name="billing_data.post_code"
                  label={t("Post code")}
                  placeholder="30-123"
                  disabled={isSubmitting}
                />
              </div>
              <div className="form__column">
                <FormikInput
                  name="billing_data.city"
                  placeholder="London"
                  label={t("City")}
                  disabled={isSubmitting}
                />
              </div>
              <div className="form__column">
                <FormikSelect
                  name="billing_data.country"
                  placeholder="United Kingdom"
                  label={t("Country")}
                  options={countries_options}
                  selected={values?.billing_data?.country}
                  disabled={isSubmitting}
                  searcher={true}
                />
              </div>
            </div>
            </Form>
          </ModalNew>
      )}
    </Formik>
  );
};

export default BillingDataModal;
